import { Map } from 'immutable';
import { createSelector } from 'reselect';
import { generateTypes } from './helpers/types';

const INITIAL_STATE = Map({
  uid: null,
  profile: null,
});

const types = generateTypes('profile', [
  'SET_PROFILE',
  'SET_UID',
]);

export default function profileReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_PROFILE:
      return state.set('profile', action.payload.profile);
    case types.SET_UID:
      return state.set('uid', action.payload.uid);
    default:
      return state;
  }
}

export function setUid(uid) {
  return {
    type: types.SET_UID,
    payload: { uid },
  };
}

export function setProfile(profile) {
  return {
    type: types.SET_PROFILE,
    payload: { profile },
  };
}

const getProfileState = state => state.profile;

export const getProfile = createSelector(getProfileState, state => state.get('profile'));
export const getUserId = createSelector(getProfileState, state => state.get('uid'));
